import { render, staticRenderFns } from "./KusUserFormPassword.vue?vue&type=template&id=bd9c728e"
import script from "./KusUserFormPassword.vue?vue&type=script&lang=js"
export * from "./KusUserFormPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports